// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__3TCig styles_toolbar__3tI-W"};